import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { landingPathForRole } from '../../utils/landingPath';

// feat-191-evaluator-role (C2, redirect site 4 of 4) — the bare `/restaurant`
// route. feat-083 made this a hardcoded `<Navigate to="/restaurant/pilot-dashboard">`;
// it now asks landingPathForRole() instead, so an evaluator is not bounced onto a
// StaffRoute-gated page they cannot pass.
//
// Behavior for Admin / Manager / Corporate — and for an unauthenticated visitor,
// and for any role we do not recognize — is UNCHANGED: still an immediate
// `replace` navigation to /restaurant/pilot-dashboard, still gated by StaffRoute
// on arrival (unauth → /scorecard-login, authed non-staff → "Access denied" in
// place, no redirect loop). See feat-083 AC#1/AC#4.
//
// The isLoading branch is what makes this correct rather than racy: on a cold
// load (deep link / refresh) AuthContext has not yet resolved the management row,
// so the role is not merely absent — it is not yet KNOWN. Redirecting during that
// window would send an evaluator to the pilot dashboard permanently.
const RestaurantLandingRedirect: React.FC = () => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-cream flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-coral mx-auto"></div>
          <p className="mt-4 text-inkMuted">Loading…</p>
        </div>
      </div>
    );
  }

  return <Navigate to={landingPathForRole(user?.managementUser?.role)} replace />;
};

export default RestaurantLandingRedirect;
